import { Link } from 'react-router-dom';

const comparisonRows = [
  { feature: 'Product Organization', spreadsheet: 5, traditional: 2 },
  { feature: 'Product Discovery Speed', spreadsheet: 5, traditional: 2 },
  { feature: 'Beginner Friendliness', spreadsheet: 5, traditional: 3 },
  { feature: 'Time Efficiency', spreadsheet: 5, traditional: 2 },
  { feature: 'Community Verification', spreadsheet: 5, traditional: 1 },
  { feature: 'Price Transparency', spreadsheet: 4, traditional: 3 },
];

export default function ArticleCTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50" id="comparison">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900">
            Why Use the Sugargoo Spreadsheet?
          </h2>
          <p className="mt-3 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Compare the Sugargoo Spreadsheet experience against traditional product searching and see why thousands of shoppers make the switch.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="overflow-hidden rounded-xl border border-background-200/60">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-6 py-4 font-semibold text-foreground-900">Feature</th>
                  <th className="text-center px-6 py-4 font-semibold text-primary-600 whitespace-nowrap">
                    Sugargoo Spreadsheet
                  </th>
                  <th className="text-center px-6 py-4 font-semibold text-foreground-600 whitespace-nowrap">
                    Traditional Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, idx) => (
                  <tr
                    key={row.feature}
                    className={`border-t border-background-200/40 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}
                  >
                    <td className="px-6 py-3.5 font-medium text-foreground-800">{row.feature}</td>
                    <td className="px-6 py-3.5 text-center">
                      <span className="text-primary-500">
                        {'★'.repeat(row.spreadsheet)}{'☆'.repeat(5 - row.spreadsheet)}
                      </span>
                    </td>
                    <td className="px-6 py-3.5 text-center">
                      <span className="text-foreground-400">
                        {'★'.repeat(row.traditional)}{'☆'.repeat(5 - row.traditional)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="text-center">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              Ready to Dive Deeper?
            </h3>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-7">
              Read our comprehensive guide covering everything about the Sugargoo Spreadsheet &mdash; from getting started to mastering advanced shopping strategies.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5">
              <Link
                to="/sugargoo-spreadsheet-ultimate-guide"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-semibold rounded-full transition-all duration-200 whitespace-nowrap"
              >
                Read Ultimate Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-background-50 hover:bg-background-200 text-foreground-800 border border-background-300 text-sm md:text-base font-semibold rounded-full transition-all duration-200 whitespace-nowrap"
              >
                Visit Main Platform
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-8" id="is-sugargoo-spreadsheet-safe">
          <div className="p-6 bg-accent-50 rounded-xl border border-accent-200/60">
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
              Is the Sugargoo Spreadsheet Safe?
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              This website provides independent educational information about Sugargoo products, shopping processes, reviews, and resources. We do not process payments or guarantee third-party products. Users should always research sellers, products, shipping rules, and local regulations before purchasing. The Sugargoo Spreadsheet is a community-curated resource, and we encourage all shoppers to exercise due diligence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}